module.exports = __webpack_public_path__ + "img/40_51.62837ed9.png";